// extracted by mini-css-extract-plugin
module.exports = {"verticalDivider":"Decorators_verticalDivider__GNajP","horizontalDivider":"Decorators_horizontalDivider__5O_FE"};